import Label from "@/app/pwa/components/form/Label";
import { InputHTMLAttributes, ReactNode } from "react";
import { ErrorText } from "./ErrorText";
import InputText from "./InputText";

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | ReactNode;
  register?: any;
  id: string;
  type?: "text" | "number" | "date";
  className?: string;
  error?: any;
  fieldsetClassName?: string;
  labelClassName?: string;
  errorClassName?: string;
  disabled?: boolean;
  selectTextOnFocus?: boolean
}

export function InputField({
  label,
  register,
  id,
  type = "text",
  className = "",
  error,
  fieldsetClassName = "",
  labelClassName = "",
  errorClassName = "",
  disabled,
  selectTextOnFocus,
  ...attributes
}: InputFieldProps) {
  // TODO: Styling for Required Fields
  return (
    <fieldset className={`fieldset flex flex-col ${fieldsetClassName ?? ""}`} disabled={disabled}>
      <InputText
        {...register}
        id={id}
        className={`peer form-field w-full ${label ? "mt-1" : ""} ${className ?? ""}`}
        type={type}
        onFocus={e => selectTextOnFocus? e.target.select() : ""}
        {...attributes}
      />
      {label && <Label
        htmlFor={id}
        className={`order-first block ${labelClassName ?? ""}`}
      >
        {label}
      </Label>}
      {error && (
        <ErrorText className={`mt-1 ${errorClassName ?? ""}`}>
          {error.message}
        </ErrorText>
      )}
    </fieldset>
  );
}
